var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon16PxWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAB00",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.053 4.581v5.938c0 .637-.038 1.269-.114 1.895a28.42 28.42 0 0 1-.301 1.915h-2.18a28.42 28.42 0 0 1-.301-1.915 15.688 15.688 0 0 1-.114-1.895V4.581h3.01zM10.69 18.077c0-.25.046-.48.14-.695a1.758 1.758 0 0 1 .96-.94 1.85 1.85 0 0 1 .727-.14c.256 0 .495.047.716.14.222.093.415.22.581.379a1.718 1.718 0 0 1 .53 1.256c0 .25-.047.483-.14.7a1.704 1.704 0 0 1-.39.567c-.166.159-.36.283-.58.373-.222.09-.461.135-.717.135-.263 0-.505-.045-.727-.135a1.743 1.743 0 0 1-.96-.94 1.76 1.76 0 0 1-.14-.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxWarning);
export default __webpack_public_path__ + "static/media/icon-16px-warning.aaaca9171d8aac35ed0cfc3d80740a89.svg";
export { ForwardRef as ReactComponent };